import styled from 'styled-components';

export const BadgeContainerStyled = styled.div`
	display: inline-block;
	margin-bottom: 8px;
	vertical-align: middle;
`;

export const NameStyled = styled(`h3`)`
	margin: 0;
	margin-bottom: 5px;
	vertical-align: center;
	font-weight: 600;
	font-size: 20px;
	line-height: 28px;
`;
